export class Utils {
  constructor() {}

  setLocalStorageSetting(key: string, val: any) {
    if (val != null)
      window.localStorage.setItem(key, val);
    else
      window.localStorage.removeItem(key);
  }
  getLocalStorageSetting(key: string): string {
    if (window.localStorage[key]) {
      return window.localStorage.getItem(key);
    }
    else {
      return "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils.ts